export const allowedThumbnailImgExtensions = ['jpeg', 'png', 'jpg'];

export const TIMEZONE = {
  IN: '+05:30'
};
